/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
export * from './getRecord.defs.js';
export { main as default } from './getRecord.defs.js';
//# sourceMappingURL=getRecord.js.map